import client from "../axios"
import { GET_TEACHER_DETAIL, POST_TEACHER, PUT_TEACHER, PUT_TEACHER_ONLINE_TEST, PUT_TEACHER_APPROVE_YN, PUT_ACADEMY_COMPLETE_DATE, PUT_BRANCH_CHECK_DATE,  } from "./endpoint"

// 강사 등록
export const postTeacherAPI = (data) => {
  return client.post(POST_TEACHER, data)
}

// 강사 상세
export const getTeacherDetailAPI = (no) => {
  return client.get(GET_TEACHER_DETAIL.replace(':teacher_idx', no))
}

// 강사 수정
export const putTeacherAPI = (data) => {
  return client.put(PUT_TEACHER.replace(':teacher_idx', data.idx), data)
}

// 강사 온라인 점수 수정
export const putTeacherOnlineTestAPI = (data) => {
  return client.put(PUT_TEACHER_ONLINE_TEST, data)
}
// 강사 승인상태 수정
export const putTeacherApproveYnAPI = (data) => {
  return client.put(PUT_TEACHER_APPROVE_YN, data)
}

// 강사 승인상태 수정
export const putAcademyCompleteDateAPI = (data) => {
  return client.put(PUT_ACADEMY_COMPLETE_DATE, data)
}

// 강사 지사 점검일 수정
export const putBranchCheckDateAPI = (data) => {
  return client.put(PUT_BRANCH_CHECK_DATE, data)
}
